export const FORGET_PASSWORD = "AUTH@FORGET_PASSWORD";
export const FORGET_PASSWORD_INIT = "AUTH@FORGET_PASSWORD_INIT";
export const FORGET_PASSWORD_SUCCESS = "AUTH@FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAILED = "AUTH@FORGET_PASSWORD_FAILED";